import type { MemberAvatarResponse } from '@kidshome/api-contract';

/**
 * Tagged-avatar helpers (ADR-0037). Kept out of `Avatar.tsx` so that file only exports components
 * (React Fast Refresh). `preset` is the steady-state default (the animal-emoji keys); `uploaded` is a
 * parent-curated photo served through the auth-gated image route.
 */

/**
 * Lift a bare preset key string to the tagged shape, for the few preset-only call sites (e.g. the
 * pre-auth kid-login picker, which never shows a photo) that carry just a key.
 */
export function presetAvatar(key: string | null | undefined): MemberAvatarResponse {
  return { kind: 'preset', key: key ?? undefined };
}

/**
 * The preset art key a tagged avatar resolves to, for the preset pickers (which only ever set a
 * preset). An `uploaded` avatar has no preset key, so the caller's `fallback` is used (the picker
 * starts from a sensible default; saving a preset reverts the photo via the update endpoint).
 */
export function avatarPresetKey(avatar: MemberAvatarResponse, fallback: string): string {
  return avatar.kind === 'preset' && avatar.key ? avatar.key : fallback;
}
